<template>
  <admin-wrapper title-translation-path="admin.MASTERPLAN_SQUARES" :moduleEnabler="moduleEnabler" :hasButtons="false">
    <template #postForm>
      <admin-tabs-layers scope="masterplan_squares" class="pt-8" schema_scope="masterplan_squares" :tab-prop="tab" />
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import AdminTabsLayers from '@/components/AdminTabsLayers';

export default {
  name: 'MasterplanSquaresSettings',
  components: {
    AdminWrapper,
    AdminTabsLayers,
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    moduleEnabler() {
      return {
        name: 'masterplan_squares_module_enabled',
        translationPath: 'admin.MASTERPLAN_SQUARES',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', {
          suffix: this.$i18n.t('admin.MASTERPLAN_SQUARES'),
        }),
      };
    },
  },
};
</script>
